module.exports = __webpack_public_path__ + "img/telegram.00550d70.svg";